export const ROUTES = {
  other: '*',
  index: '/',
  view: '/view',
  memo: '/view/memo/:memoId',
  home: '/home',
  dashboard: '/home/dashboard',
  edit: '/home/edit',
  user_group: '/home/userGroup',
  messages: '/home/messages',
  training: '/home/training',
  authentication_test: '/home/authentication-test',
  settings: '/home/settings'
};

export const ROUTES_LIST = {
  memo: '/view/memo',
  edit: '/home/edit'
};

export const VIEW_ROUTES_LIST = {
  memo: '/share/memo'
};
